// removed by extract-text-webpack-plugin
module.exports = {"page":"_28WJZ","table":"_2moCo","button":"_3XaY7","deleteButton":"_2k8vB _3XaY7"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ExternalShares.css
// module id = 357
// module chunks = 0